var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.954v-4.5h6v4.5h-6Zm6 3h-6v3.032h6v-3.032Zm3 3.032v-3.032h6v3.032h-6Zm0-6.032v-4.5h6v4.5h-6Zm0-7.5h6V3h-6v4.454ZM10.5 3h-6v4.454h6V3Zm-9 13.454V2.999C1.5 1.565 2.54 0 4.286 0h15.428C21.46 0 22.5 1.565 22.5 2.999v17.988c0 1.434-1.04 3-2.786 3H4.286c-1.745 0-2.786-1.566-2.786-3v-4.533Z"
  })));
};
export default SvgTable;